export default "__VITE_ASSET__DBtE4_yC__"